import { readPUuidCookie } from "../common/p_uuid_cookie";

$(document).ready(function() {
  $('.x-remind-password-form, .x-reset-password-form, .x-user-authentication-form, .x-user-registration-form, .x-remind-username-form, .x-email-confirmation-form, .x-user-subscription-form, .x-contact-form').on('submit', function(event) {

    event.preventDefault();
    var form = $(this);
    var fields = {
      'button' : form.find('button')[0],
      'email' : form.find('.x-email-field'),
      'password' : form.find('.x-password-field'),
      'password_confirmation' : form.find('.x-password-confirmation-field'),
      'last_name' : form.find('.x-lastname-field'),
      'first_name' : form.find('.x-firstname-field'),
      'phone' : form.find('.x-phone-field'),
      'login' : form.find('.x-login-field'),
      'name' : form.find('.x-name-field'),
      'content' : form.find('.x-content-field')
    }

    $.ajax({
      type: 'POST',
      url: form.attr('action'),
      data: form.serialize(),
      dataType: 'json',
      beforeSend: function() {
        form.find('.x-form-field').removeClass('error');
        fields['button'].disabled = true;
        toastr.remove();
      }
    }).done(function(data) {
      fields['button'].disabled = false;
      if (data.url !== undefined) {
        sendAnalyticsForLPRegistration(form);
        document.location = data.url;
      } else if (data.message !== undefined) {
        toastr.success(data.message);
      }

      if(data.clear === true) {
        form.find('input,select,textarea').val('');
      }
    }).fail(function(data) {
      fields['button'].disabled = false;
      fields['password'].val('');
      fields['password_confirmation'].val('');
      var errors = JSON.parse(data.responseText).errors;
      showErrors(fields, errors);
    });
  });

  function showErrors(fields, errors) {
    var messages = [];

    $.each(errors, function(field_key, message) {
      messages.push(message);

      if (field_key === 'base') {
        $.each(['login', 'password', 'password_confirmation'], function(index, value) {
          fields[value].parent('.x-form-field').addClass('error');
        });
      }

      if (fields[field_key] !== undefined) {
        fields[field_key].parent('.x-form-field').addClass('error');
      }
    });
    toastr.error(messages.reduce(function(a, b) {
        return a.concat(b);
      }, []).join('<br>')
    );
  }

  const orderingForms = document.querySelectorAll('.x-ordering-form');

  orderingForms.forEach(function(form) {
    const isLoggedOrderingForm = form.classList.contains('x-logged-ordering-form');
    const fields = form.querySelectorAll('.field.material-form-control');
    const nameInput = form.querySelector('input[name="name"]');
    const surnameInput = form.querySelector('input[name="surname"]');
    const phoneInput = form.querySelector('input[name="phone"]');
    const emailInput = form.querySelector('input[name="email"]');
    const termsCheckbox = form.querySelector('.terms-checkbox');
    const submitButton = form.querySelector('button[type="submit"]');

    form.addEventListener('submit', function(event) {
      this.querySelector('button[type="submit"]').classList.add('disabled');
      this.querySelector('button[type="submit"]').setAttribute('disabled', 'true');

      let valid = true;

      fields.forEach(function(field) {
        const input = field.querySelector('input');
        const label = field.querySelector('label');

        if (!input) {
          return;
        }

        if (/[<>]/.test(input.value) || !input.value) {
          field.classList.add('error');
          label.classList.add('error');
          valid = false;
        } else {
          field.classList.remove('error');
          label.classList.remove('error');
        }
      });

      const messages = [];

      if (isLoggedOrderingForm) {
        if (!nameInput.value) {
          messages.push('Proszę wprowadzić imię.');
          valid = false;
        } else if (/[<>]/.test(nameInput.value)) {
          messages.push('Wprowadzone imię zawiera niedozwolone znaki.');
          valid = false;
        }

        if (!surnameInput.value) {
          messages.push('Proszę wprowadzić nazwisko.');
          valid = false;
        } else if (/[<>]/.test(surnameInput.value)) {
          messages.push('Wprowadzone nazwisko zawiera niedozwolone znaki.');
          valid = false;
        }

        if (!phoneInput.value) {
          messages.push('Proszę wprowadzić numer telefonu.');
          valid = false;
        } else if (!/^[0-9]{9}$/.test(phoneInput.value)) {
          messages.push('Wprowadzony numer telefonu jest nieprawidłowy.');
          valid = false;
        } else if (/[<>]/.test(phoneInput.value)) {
          messages.push('Wprowadzony numer telefonu zawiera niedozwolone znaki.');
          valid = false;
        }
      } else {
        if (/[<>]/.test(nameInput.value)) {
          messages.push('Wprowadzone imię zawiera niedozwolone znaki.');
          valid = false;
        }

        if (/[<>]/.test(surnameInput.value)) {
          messages.push('Wprowadzone nazwisko zawiera niedozwolone znaki.');
          valid = false;
        }

        if (/[<>]/.test(emailInput.value)) {
          messages.push('Wprowadzony email zawiera niedozwolone znaki.');
          valid = false;
        }

        if (/[<>]/.test(phoneInput.value)) {
          messages.push('Wprowadzony numer telefonu zawiera niedozwolone znaki.');
          valid = false;
        }

        if (termsCheckbox) {
          if (!termsCheckbox.checked) {
            messages.push('Musisz zaakceptować regulamin oraz politykę prywatności.');
            valid = false;
          } else {
            valid = true;

            this.querySelector('button[type="submit"]').removeAttribute('disabled');
          }
        }
      }

      if (!valid) {
        event.preventDefault();

        this.querySelector('button[type="submit"]').classList.remove('disabled');
        this.querySelector('button[type="submit"]').removeAttribute('disabled');

        toastr.error(messages.reduce(function(a, b) {
          return a.concat(b);
        }, []).join('<br>'));
      } else {
        event.preventDefault();

        var f = this;
        var submitForm = function() { HTMLFormElement.prototype.submit.call(f); };

        if (!isLoggedOrderingForm && typeof dataLayer !== 'undefined') {
          dataLayer.push({
            'event': 'account_registration',
            'registrationDetails': {
              'product': 'software_na_jdg_obr'
            },
            'p_uuid': readPUuidCookie(),
            'eventCallback': submitForm,
            'eventTimeout': 2000
          });
        } else {
          submitForm();
        }
      }
    });
  });
});
